import NP from 'number-precision';

function fillZero(n: number) {
  let str = n.toString();
  if (str.includes('.')) {
    let decimalPlaces = str.split('.')[1].length;
    while (decimalPlaces < 2) {
      decimalPlaces++;
      str += '0';
    }
    // console.log({ originNumber: n, isDecimal: true, decimalPlaces });
    return str;
  } else {
    // console.log({ originNumber: n, isDecimal: false, decimalPlaces: 0 });
    return n.toString() + '.00';
  }
}

export default {
  /**
   * 向上取整 - 单位：分
   * @param value - 数值
   * @param isFillZero - 是否补零 2.3 => 2.30
   * @returns
   */
  roundedUp: (value: string | number, isFillZero = false) => {
    const n = NP.divide(Math.ceil(NP.times(+value, 100)), 100);
    if (!isFillZero) return n.toString();
    return fillZero(n);
  },
  /**
   * 向下取整 - 单位：分
   * @param value
   * @param isFillZero
   * @returns
   */
  roundedDown: (value: string | number, isFillZero = false) => {
    const n = NP.divide(Math.floor(NP.times(+value, 100)), 100);
    if (!isFillZero) return n.toString();
    return fillZero(n);
  },
};
